import { PageHeaderComponent, LoaderSpinnerComponent } from "@aston/foundation/components";
import { redirectToNotFoundOn, StoreLoader, UnsubscriberClass } from "@aston/foundation";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { TranslateDirective } from "@ngx-translate/core";
import { Component, OnInit, inject } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { takeUntil } from "rxjs/operators";
import { Store } from "@ngrx/store";

import { FederationsStoreActions, FederationsStoreSelectors } from "../../../root-store/federations-store";
import { FederationFormComponent } from "../../components/federation-form/federation-form.component";
import { IFederationForm } from '../../../federations-module/models/federation.model';
import { SubsidiariesStoreActions } from "../../../root-store/subsidiaries-store";
import { AppStoreActions } from "../../../root-store/app-store";
import * as RoutesDefinitions from '../../../routes-definitions';

@Component({
	selector: 'federation-form-page',
	templateUrl: './federation-form-page.component.html',
	imports: [PageHeaderComponent, TranslateDirective, RouterLink, LoaderSpinnerComponent, FederationFormComponent, AsyncPipe]
})
export class FederationFormPageComponent extends UnsubscriberClass implements OnInit {
	private store = inject(Store);
	private route = inject(ActivatedRoute);
	private router = inject(Router);

	federationsRoutePath = RoutesDefinitions.getFederationsFullPath();

	entity$ = this.store.select(FederationsStoreSelectors.selectFederationEntity);

	loader = new StoreLoader(
		this.store.select(FederationsStoreSelectors.selectFederationEntityIsLoading),
		this.store.select(FederationsStoreSelectors.selectFederationEntityError)
	);

	ngOnInit() {
		this.store.dispatch(SubsidiariesStoreActions.LoadSubsidiariesRequest());

		this.route.params.pipe(
			takeUntil(this.destroySubscriptions$)
		).subscribe(params => {
			if (!params.id)
				return this.store.dispatch(FederationsStoreActions.NewFederation())

			this.store.dispatch(FederationsStoreActions.LoadFederationRequest(params.id))

			redirectToNotFoundOn(this.store, FederationsStoreSelectors.selectFederationEntityError)
				.until(this.destroySubscriptions$)
				.on('UnauthorizedAccess')
				.with((fromError, message) => AppStoreActions.NotFound({ fromError, message }))
				.subscribe();
		})
	}

	onCancel() {
		this.router.navigate([RoutesDefinitions.getSubsidiariesFullPath()]);
	}

	onDelete(id: number) {
		this.store.dispatch(FederationsStoreActions.DeleteFederationConfirm({
			entity: { federationId: id} as IFederationForm
		}));
	}

	onSubmit(value) {
		this.store.dispatch(value.federationId ?
			FederationsStoreActions.UpdateFederationRequest(value) :
			FederationsStoreActions.CreateFederationRequest(value))
	}
}
